export type BaseMapId = 'osm' | 'esri' | 'carto' | 'custom'

export const BASEMAPS: Record<
  BaseMapId,
  {
    name: string
    url: string
    attribution: string
    options?: {
      subdomains?: string | string[]
      maxZoom?: number
      tileSize?: number
      detectRetina?: boolean
    }
  }
> = {
  osm: {
    name: 'OpenStreetMap',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenStreetMap contributors',
    options: { subdomains: ['a', 'b', 'c'], maxZoom: 19, detectRetina: true },
  },
  esri: {
    name: 'ESRI Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution:
      'Tiles &copy; Esri — Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community',
    options: { maxZoom: 19 },
  },
  carto: {
    name: 'Carto Positron (Light)',
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
    options: { subdomains: 'abcd', maxZoom: 20, detectRetina: true },
  },
  custom: {
    name: 'Custom XYZ',
    url: (import.meta as any).env?.VITE_CUSTOM_XYZ_URL || '',
    attribution: (import.meta as any).env?.VITE_CUSTOM_XYZ_ATTR || '',
    options: { maxZoom: 20 },
  },
}

export function availableBaseMaps(): Array<[BaseMapId, typeof BASEMAPS[keyof typeof BASEMAPS]]> {
  return (Object.entries(BASEMAPS) as Array<[BaseMapId, any]>).filter(([id, cfg]) =>
    id !== 'custom' ? true : Boolean(cfg.url)
  )
}

